import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { appConstants } from '../app-constants';
import { SharedModule } from '../shared/shared.module';
import { AppValidators } from '../app-validators';
import { MessageModule } from 'primeng/message';
import { PasswordModule } from 'primeng/password';
import { AppValidationHelpers } from '../app-validation-helpers';
import { ChangePasswordGQL, Language } from '../graphql/gql';
import { LanguageService } from '../services/language.service';
import { ToastService } from '../toast/toast.service';
import { Router } from '@angular/router';
import { SessionDataService } from '../services/session-data.service';

@Component({
  selector: 'app-password-expired',
  imports: [
    ReactiveFormsModule,
    FloatLabelModule,
    InputTextModule,
    ButtonModule,
    SharedModule,
    MessageModule,
    PasswordModule,
  ],
  templateUrl: './password-expired.component.html',
  styleUrl: './password-expired.component.scss',
})
export class PasswordExpiredComponent {

  form = new FormGroup({
    currentPassword: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
    password: new FormControl('', [Validators.required, Validators.pattern(AppValidators.PASSWORD_REGEX), AppValidators.validateEqualsReverse('passwordConfirmation')]),
    passwordConfirmation: new FormControl('', [Validators.required, AppValidators.validateEquals('password')]),
  });

  constructor(
    private changePasswordGQL: ChangePasswordGQL,
    private languageService: LanguageService,
    private toastService: ToastService,
    private router: Router,
    private sessionDataService: SessionDataService,
  ) { }

  async onSubmit() {
    this.form.markAllAsDirty()
    if (this.form.valid) {
      this.changePasswordGQL.mutate({
        currentPassword: this.form.get('currentPassword')?.value!,
        password: this.form.get('password')?.value!,
        language: this.languageService.getCurrentLanguage() as Language
      }).subscribe(async (result) => {
        const validationErrors = result.data?.changePassword.validationMessages!
        if(validationErrors.length !== 0) {
          // An error whose attribute has no control in this form has nowhere to render, so show it
          // as a toast rather than failing silently. See BNDDEV-10062.
          const unmapped = AppValidationHelpers.applyValidationErrors(validationErrors, this.form);
          const unmappedMessage = AppValidationHelpers.unmappedErrorMessage(unmapped);

          if (unmappedMessage !== null) {
            this.toastService.show('error', unmappedMessage);
          }
        } else {
          await this.sessionDataService.refresh()
          this.toastService.show('success', $localize`:password expired|password changes success message:Password changed successfully`)
          this.router.navigateByUrl('/')
        }
      });
    } else {
      // Mark all fields as touched to show validation errors
      this.form.markAllAsTouched();
    }
  }

  logoUrl(): string {
    // Add a query parameter to avoid caching issues
    return appConstants.LOGO_URL + "?for=password-expired";
  }

  getRemoteValidationMessages = AppValidationHelpers.getRemoteValidationMessages
}
